import { render, staticRenderFns } from "./editPriceDetaile.vue?vue&type=template&id=0d7b819a&scoped=true"
import script from "./editPriceDetaile.vue?vue&type=script&lang=js"
export * from "./editPriceDetaile.vue?vue&type=script&lang=js"
import style0 from "./editPriceDetaile.vue?vue&type=style&index=0&id=0d7b819a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b819a",
  null
  
)

export default component.exports